import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-68933f28"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-bottom-notification-section" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dummy-background-notification" }, null, -1))
const _hoisted_3 = { class: "modal-dialog" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "modal-header" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "modal-body" }
const _hoisted_8 = { class: "body-title" }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { class: "body-description" }
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = { class: "modal-footer" }
const _hoisted_13 = ["onClick"]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", {
      class: _normalizeClass([['modal-bottom', _ctx.modalOptions.classNameHeader], {show: _ctx.active}])
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (_ctx.modalOptions?.image)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: require('../../assets/img/' + _ctx.modalOptions.image + '.png')
                }, null, 8, _hoisted_6))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", {
                innerHTML: _ctx.modalOptions.body?.title
              }, null, 8, _hoisted_9)
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("span", {
                innerHTML: _ctx.modalOptions.body?.description
              }, null, 8, _hoisted_11)
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modalOptions.actionOptions, (item) => {
              return (_openBlock(), _createElementBlock("button", {
                class: "btn",
                style: _normalizeStyle({color: item.color ? item.color : '#424242', backgroundColor: item.backgroundColor ? item.backgroundColor : '#E8E8E8', borderColor: item.backgroundColor ? item.backgroundColor : '#E8E8E8'}),
                onClick: $event => (item?.action ? item.action() : _ctx.closeModal())
              }, [
                _createElementVNode("span", null, _toDisplayString(item.text ? item.text : 'Close'), 1)
              ], 12, _hoisted_13))
            }), 256))
          ])
        ])
      ])
    ], 2)
  ]))
}